import { useState } from "react";
import { api } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { fmtMoney, fmtSigned, fmtDateTime, pnlClass, LEDGER_KIND } from "@/lib/format";
import { PageHeader, StatCard, Empty } from "@/components/kit";
import { PositionsPanel } from "@/components/trade/PositionsPanel";

export default function Portfolio() {
  const [b, setB] = useState(null);
  const [ledger, setLedger] = useState([]);
  usePoll(() => api.get("/me/dashboard").then((r) => setB(r.data.balances)), 5000);
  usePoll(() => api.get("/me/ledger").then((r) => setLedger(r.data)), 15000);
  return (
    <div data-testid="portfolio-page">
      <PageHeader eyebrow="Investimentos" title="Carteira" desc="Posições abertas, ordens pendentes, operações encerradas e o extrato completo da sua conta demo." />
      {b && (
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
          <StatCard testid="pf-equity" label="Patrimônio" value={fmtMoney(b.equity)} />
          <StatCard testid="pf-available" label="Disponível" value={fmtMoney(b.available)} tone="up" />
          <StatCard testid="pf-invested" label="Margem em uso" value={fmtMoney(b.invested)} />
          <StatCard testid="pf-unrealized" label="Não realizado" value={fmtSigned(b.unrealized_pnl)} tone={pnlClass(b.unrealized_pnl)} />
          <StatCard testid="pf-realized" label="Realizado" value={fmtSigned(b.realized_pnl)} tone={pnlClass(b.realized_pnl)} />
        </div>
      )}
      <PositionsPanel link />
      <div className="surface p-5 md:p-6 mt-6" data-testid="ledger-table">
        <div className="eyebrow mb-4">Extrato da conta</div>
        {ledger.length === 0 ? <Empty text="Nenhum lançamento." /> : (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left eyebrow"><th className="py-2">Data</th><th>Tipo</th><th>Descrição</th><th className="text-right">Valor</th></tr></thead>
            <tbody>{ledger.map((l) => (
              <tr key={l.id} className="border-t border-border"><td className="py-3 text-xs text-muted-foreground">{fmtDateTime(l.created_at)}</td>
                <td>{LEDGER_KIND[l.kind] || l.kind}</td><td className="text-muted-foreground">{l.description}</td>
                <td className={`text-right num font-semibold ${pnlClass(l.amount)}`}>{fmtSigned(l.amount, l.currency || "USD")}</td></tr>))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
